import { render, staticRenderFns } from "./SettingsPrograms.vue?vue&type=template&id=3e00eece"
import script from "./SettingsPrograms.vue?vue&type=script&lang=js"
export * from "./SettingsPrograms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports